import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useLazyQuery } from '@apollo/react-hooks';

import styles from './LowUsageSchools.module.scss';
import commonStyles from '../../DataDashboard.module.scss';
import BackLink from '../../../../components/BackLink';
import { Button } from '@squirrellearningltd/go-teacher-components';
import Tabs from '../../../../components/Tabs';
import Tab from '../../../../components/Tab';

import { SCHOOL_USAGE_SCORE } from '../../services/graphql';
import useClipboard from '../../utils/copyToClipboard';

import { navigate } from '@reach/router';

const TABS = {
    highPrioritySupport: 1,
    outReachList: 2,
};

const SUPPORT_TAB = {
    student: 1,
    teacher: 2,
    parent: 3,
};

const DATA_FOR = {
    student: "student",
    teacher: "teacher",
    parent: "parent",
};


const LowUsageSchools = () => {
    const [selectedTab, setSelectedTab] = useState(TABS.highPrioritySupport);
    const [selectedSupportTab, setSelectedSupportTab] = useState(SUPPORT_TAB.student);
    const { copyToClipboard, isCopied, error } = useClipboard();

    const [
        handleSchoolUsageScore,
        {
            data: schoolData,
            loading: schoolDataLoading,
            error: schoolDataError,
        },
    ] = useLazyQuery(SCHOOL_USAGE_SCORE);

    const getSchoolUsageScore = (support, orderBy = DATA_FOR.student) => {
        handleSchoolUsageScore({
            variables: {
                support,
                orderBy,
            }
        })
    };

    const copyEmails = () => {
        if (schoolData.schoolUsageScore) {
            const adminEmails = schoolData.schoolUsageScore.map((schoolUsage) => schoolUsage.school.admins.map((admin) => admin.email)).flat();
            const copyParser = (data) => data.filter(Boolean).join(';');
            copyToClipboard(adminEmails, copyParser);
        } else {
            alert('No data to copy');
        }

    };

    useEffectOnce(() => {
        if (!schoolData) {
            getSchoolUsageScore('priority', DATA_FOR.student)
        }
    })

    return (
        <>
            <BackLink to='/dataDashboard' text='Back' />

            <div className={commonStyles.dataDashboardHeader}>
                <h2>Low Usage Schools</h2>
                <Button type='button' onClick={() => copyEmails()}>
                    Copy Emails
                </Button>
            </div>

            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.highPrioritySupport}
                    onClick={() => {
                        setSelectedTab(TABS.highPrioritySupport);
                        setSelectedSupportTab(SUPPORT_TAB.student);
                        getSchoolUsageScore('priority', DATA_FOR.student)
                    }}
                >
                    High-priority support
                </Tab>
                <Tab
                    selected={selectedTab === TABS.outReachList}
                    onClick={() => {
                        setSelectedTab(TABS.outReachList);
                        setSelectedSupportTab(SUPPORT_TAB.student);
                        getSchoolUsageScore('outreach', DATA_FOR.student)

                    }}
                >
                    Outreach list
                </Tab>
            </Tabs>

            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedSupportTab === SUPPORT_TAB.student}
                    onClick={() => {
                        setSelectedSupportTab(SUPPORT_TAB.student);
                        getSchoolUsageScore(selectedTab === 1 ? 'priority' : 'outreach', DATA_FOR.student)
                    }}
                >
                    Student
                </Tab>
                <Tab
                    selected={selectedSupportTab === SUPPORT_TAB.teacher}
                    onClick={() => {
                        setSelectedSupportTab(SUPPORT_TAB.teacher);
                        getSchoolUsageScore(selectedTab === 1 ? 'priority' : 'outreach', DATA_FOR.teacher)

                    }}
                >
                    Staff
                </Tab>

                <Tab
                    selected={selectedSupportTab === SUPPORT_TAB.parent}
                    onClick={() => {
                        setSelectedSupportTab(SUPPORT_TAB.parent);
                        getSchoolUsageScore(selectedTab === 1 ? 'priority' : 'outreach', DATA_FOR.parent)

                    }}
                >
                    Parent
                </Tab>
            </Tabs>

            {schoolDataError && <p>{schoolDataError.message}</p>}

            {selectedSupportTab === 1 ? (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Usage </div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.schoolUsageScore.length ? schoolData.schoolUsageScore.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.studentLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            ) : selectedSupportTab === 2 ? (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Usage</div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.schoolUsageScore.length ? schoolData.schoolUsageScore.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.teacherLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Usage</div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.schoolUsageScore.length ? schoolData.schoolUsageScore.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.parentLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default LowUsageSchools;
